import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";

// Router
import { withRouter } from "react-router-dom";

//Redux
import { connect } from "react-redux";
import { getNotifications } from "../../redux/actions/notifications";
import { showModal } from "../../redux/actions/modal";

//Table Helpers
import {
  // filterDataByColumns,
  attachActionButtons,
  TableFetchSelect,
  onTableFetchSelectChange,
  tableFetchSelectOptions,
} from "../../helpers/tableControllers";

// UI Components
import { Loader, InfoLoader } from "../../UI/Loaders/Loaders";
// import { InfoLoader } from '../../UI/Loaders';
import BreadCrumbs from "../../UI/BreadCrumbs/BreadCrumbs";

export class Notifications extends Component {
  // Component StateFunder
  state = {
    tabs: [
      // Tabs array passed as props to the Tabs UI Component to configure & display
      {
        identifier: "notificationTab",
        name: "All",
        id: "all",
        icon: "fas fa-hourglass-start",
      },
      {
        identifier: "notificationTab",
        name: "Repayments",
        id: "repayments",
        icon: "fas fa-hourglass-start",
      },
      {
        identifier: "notificationTab",
        name: "Disbursements",
        id: "disbursements",
        icon: "fas fa-check-circle",
      },
      {
        identifier: "notificationTab",
        name: "Payouts",
        id: "payouts",
        icon: "fas fa-times-circle",
      },
      {
        identifier: "notificationTab",
        name: "Fund Wallet",
        id: "fundwallet",
        icon: "fas fa-ban",
      },
    ],
  };

  // Open Modal
  modalHandler = (modalData) => {
    this.props.showModal({
      modalIdentifier: "notifications",
      dataRecord: modalData.dataRecord,
      action: "customrange",
    });
  };

  //  Life Cycle Hooks
  componentDidMount() {
    //  If user is not authenticates, redirect to login
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }

    //  On Mount, get Notification data from API to render in the UI
    //  Notification data: An object with two properties - columns & rows
    this.props.getNotifications();
  }

  //JSX Template
  render() {
    let { notificationsTableData, loading, error } =
      this.props.allNotifications;

    let RenderedComponent = null;

    if (loading) {
      RenderedComponent = (
        <Loader text="Loading Notifications" centered="true" />
      );
      RenderedComponent = <Loader text="Loading Notifications" />;
    } else if (error) {
      RenderedComponent = (
        <div className="centerLoader">
          <InfoLoader
            centered="true"
            text="There was an issue fetching your notification."
            subText="Kindly reload the page."
          />
        </div>
      );
    } else if (notificationsTableData) {
      if (notificationsTableData.rows.length !== 0) {
        const tableName = "Notifications";
        const actions = ["view"];
        let rowsWithActionButton = attachActionButtons(
          notificationsTableData.rows,
          tableName,
          actions,
          this.modalHandler
        );
        notificationsTableData = {
          ...notificationsTableData,
          rows: [...rowsWithActionButton],
        };
      }
      RenderedComponent = (
        <div className="grid__padding">
          <MDBDataTable
            responsive
            minimal="true"
            striped
            bordered
            hover
            data={notificationsTableData}
          />
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="mt-40 tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are Currently No Notifications
              to View
            </h4>
          </div>
        </div>
      );
    }

    return (
      <div className="FunderNotifications datatable-wrapper">
        <div className="table-view speed-1x fadeInRight">
          <div className="col-lg-9 col-md-6 col-sm-7 dashboard-title flex__row">
            {/* Bread Crumbs */}
            <BreadCrumbs
              name="Notifications"
              currentPath={this.props.location.pathname}
            />
          </div>
          <div
            className="m-l-1 m-r-1 m-b-1"
            style={{
              display: "flex",
              justifyContent: "center",
              height: "30px",
            }}
          >
            <TableFetchSelect
              // style={{ marginRight: '20px' }}
              label="Showing results for: "
              id="table-fetch"
              className="table-fetch-select"
              onChange={(e) =>
                onTableFetchSelectChange(
                  e,
                  this.props.showModal,
                  this.props.getNotifications,
                  "getNotifications",
                  `searchvalue=`
                )
              }
              options={[...tableFetchSelectOptions]}
            />
          </div>

          {/* All Notifications Datatable || Loader || Error Message*/}
          {RenderedComponent}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  authReducer,
  notificationsReducer: { allNotifications },
}) => {
  const { isAuthenticated, loggedInUser } = authReducer;

  return {
    isAuthenticated,
    loggedInUser,
    allNotifications,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getNotifications,
    showModal,
  })(Notifications)
);
